

export default {
  init () {
    $('.expand-list .title').click(function () {
      $('.expand-list').toggleClass('is-expand')
    });
    $('.local-warp .cur-local').click(function () {
      $('.local-warp').toggleClass('is-expand')
    });
    // 设置版权年份
    var currentYear = new Date().getFullYear();
    $('.copyright-year').text(currentYear);
  }
}